import React from 'react';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _keyBy from 'lodash/keyBy';
import makeStyles from '@material-ui/core/styles/makeStyles';
import * as AttributeEditTypes from 'pages/AttributesEdit/typings';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

interface Props {
  values: AttributeEditTypes.AttributesEditFormValues;
  onChange: (field: string, value: any) => void;
}

function DefaultOrgChartStartingPosition({ values, onChange }: Props) {
  const classes = useStyles();
  const startingPositionValue = _get(
    values,
    ['client', 'settings', 'orgChart', 'startingPosition'],
    'user',
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onChange('client.settings.orgChart.startingPosition', value);
  };

  return (
    <Card>
      <CardHeader
        className={classes.header}
        title="Default Starting Position"
        subheader="Choose which position the org chart starts on when a user navigates to the main Org Chart page."
      />
      <CardContent>
        <RadioGroup value={startingPositionValue} onChange={handleChange}>
          <FormControlLabel
            control={<Radio />}
            value="user"
            label={
              <>
                <strong>Start on the User (Default)</strong> - If the logged in user has a card on
                the org chart, it will navigate to their card.
              </>
            }
          />
          <FormControlLabel
            control={<Radio />}
            value="root"
            label={
              <>
                <strong>Start on the Top</strong> - Always start at the top of the org chart.
              </>
            }
          />
        </RadioGroup>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    paddingBottom: 0,
  },
}));

export default DefaultOrgChartStartingPosition;
